export default {
  statusPublish: 'publish',
  statusWaiting: 'waiting',
  statusAccepted: 'accepted',
  statusDeclined: 'declined',
}
